import { FC } from "react";
import styled, { css } from "styled-components";

const Wrapper = styled.div<{ isActive?: boolean }>`
    ${({ isActive}) => isActive ? css`
        path {
            fill: #151514 !important;
        }
    ` : css`
        path {
            fill: #909090 !important;
        }
    `};
`;

export const PinIcon: FC<{ isActive?: boolean, onClick: () => void }> = ({ isActive, onClick}) => {
    return (
        <Wrapper isActive={isActive} onClick={onClick}>
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.024 4.60614C17.525 4.10784 18.2028 3.82812 18.9093 3.82812C19.6159 3.82812 20.2937 4.10784 20.7947 4.60614L27.3947 11.2061C27.8946 11.7062 28.1754 12.3844 28.1754 13.0915C28.1754 13.7986 27.8946 14.4767 27.3947 14.9768C27.1474 15.225 26.8535 15.4219 26.5299 15.5563C26.2063 15.6907 25.8594 15.7598 25.509 15.7598C25.1586 15.7598 24.8117 15.6907 24.4881 15.5563C24.1645 15.4219 23.8707 15.225 23.6234 14.9768L23.152 14.5055L19.2167 18.4408C20.4033 21.6541 19.6093 25.6188 17.0233 28.1761C16.8979 28.3003 16.7285 28.37 16.552 28.37C16.3755 28.37 16.2061 28.3003 16.0807 28.1761L10.424 22.5195L6.18135 26.7621C6.05561 26.8836 5.88721 26.9508 5.71241 26.9493C5.53762 26.9477 5.37041 26.8776 5.2468 26.754C5.1232 26.6304 5.05309 26.4632 5.05157 26.2884C5.05005 26.1136 5.11724 25.9452 5.23868 25.8195L9.48135 21.5768L3.82468 15.9201C3.76189 15.8587 3.712 15.7853 3.67795 15.7043C3.64389 15.6233 3.62634 15.5363 3.62634 15.4485C3.62634 15.3606 3.64389 15.2736 3.67795 15.1926C3.712 15.1116 3.76189 15.0383 3.82468 14.9768C6.34668 12.4548 10.178 11.5521 13.5593 12.7835L17.4947 8.84814L17.024 8.37747C16.5242 7.8772 16.2435 7.19897 16.2435 6.49181C16.2435 5.78465 16.5242 5.10641 17.024 4.60614Z" fill={isActive ? '#151514' : '#909090'} />
            </svg>
        </Wrapper>
    )
}import { FC } from "react";
import styled, { css } from "styled-components";

const Wrapper = styled.div<{ isActive?: boolean }>`
    ${({ isActive}) => isActive ? css`
        path {
            fill: #151514 !important;
        }
    ` : css`
        path {
            fill: #909090 !important;
        }
    `};
`;

export const PinIcon: FC<{ isActive?: boolean, onClick: () => void }> = ({ isActive, onClick}) => {
    return (
        <Wrapper isActive={isActive} onClick={onClick}>
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.024 4.60614C17.525 4.10784 18.2028 3.82812 18.9093 3.82812C19.6159 3.82812 20.2937 4.10784 20.7947 4.60614L27.3947 11.2061C27.8946 11.7062 28.1754 12.3844 28.1754 13.0915C28.1754 13.7986 27.8946 14.4767 27.3947 14.9768C27.1474 15.225 26.8535 15.4219 26.5299 15.5563C26.2063 15.6907 25.8594 15.7598 25.509 15.7598C25.1586 15.7598 24.8117 15.6907 24.4881 15.5563C24.1645 15.4219 23.8707 15.225 23.6234 14.9768L23.152 14.5055L19.2167 18.4408C20.4033 21.6541 19.6093 25.6188 17.0233 28.1761C16.8979 28.3003 16.7285 28.37 16.552 28.37C16.3755 28.37 16.2061 28.3003 16.0807 28.1761L10.424 22.5195L6.18135 26.7621C6.05561 26.8836 5.88721 26.9508 5.71241 26.9493C5.53762 26.9477 5.37041 26.8776 5.2468 26.754C5.1232 26.6304 5.05309 26.4632 5.05157 26.2884C5.05005 26.1136 5.11724 25.9452 5.23868 25.8195L9.48135 21.5768L3.82468 15.9201C3.76189 15.8587 3.712 15.7853 3.67795 15.7043C3.64389 15.6233 3.62634 15.5363 3.62634 15.4485C3.62634 15.3606 3.64389 15.2736 3.67795 15.1926C3.712 15.1116 3.76189 15.0383 3.82468 14.9768C6.34668 12.4548 10.178 11.5521 13.5593 12.7835L17.4947 8.84814L17.024 8.37747C16.5242 7.8772 16.2435 7.19897 16.2435 6.49181C16.2435 5.78465 16.5242 5.10641 17.024 4.60614Z" fill={isActive ? '#151514' : '#909090'} />
            </svg>
        </Wrapper>
    )
}